(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dynadux", [], factory);
	else if(typeof exports === 'object')
		exports["dynadux"] = factory();
	else
		root["dynadux"] = factory();
})(global, () => {
return 